var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuJungsan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Material/Icons/\uC815\uC0B0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Material/Icons/\\uC815\\uC0B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u110C\\u1161\\u1109\\u1161\\u11AB-50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.38,16.49 C7.38,16.64 7.38,16.8 7.38,16.95 C7.3965573,17.2254504 7.29855623,17.4954995 7.10919537,17.696222 C6.91983452,17.8969446 6.65594711,18.0104972 6.38,18.0100016 L3.08,18.0100016 C2.52771525,18.0100016 2.08,17.5622847 2.08,17.01 L2.08,16.1699992 C2.08,15.6177153 2.52771525,15.1699992 3.08,15.1699992 L6.36,15.1699992 C6.63411126,15.1696571 6.89634636,15.2818495 7.08538875,15.480344 C7.27443115,15.6788386 7.37370579,15.9462314 7.36,16.22 L7.38,16.49 Z",
    id: "Path",
    fill: "#FFE98A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.39,11.36 L7.23,11.36 C7.58431874,11.3413071 7.92201218,11.5117637 8.11740002,11.8079305 C8.31278785,12.1040974 8.3366098,12.481622 8.18,12.8 C8.06,13.06 7.96,13.32 7.87,13.58 C7.70671089,13.9895326 7.31088389,14.258695 6.87,14.26 L1.38,14.26 C0.82771525,14.26 0.38,13.8122847 0.38,13.26 L0.38,12.4 C0.369022334,12.1261781 0.470898788,11.859849 0.661819469,11.6632574 C0.85274015,11.4666658 1.11597409,11.3570396 1.39,11.36 Z",
    id: "Path",
    fill: "#FFE98A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.23,7.62 C13.2450177,7.86364812 11.401307,8.77316511 10,10.2 C9.80979613,10.3995342 9.54566015,10.5117015 9.27,10.51 L2.19,10.51 C1.63771525,10.51 1.19,10.0622847 1.19,9.51 L1.19,8.65 C1.19,8.09771525 1.63771525,7.65 2.19,7.65 L15.23,7.62 Z",
    id: "Path",
    fill: "#FFE98A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFE98A",
    fillRule: "nonzero",
    x: 2.85,
    y: 3.87,
    width: 14.08,
    height: 2.9,
    rx: 1.45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFE98A",
    fillRule: "nonzero",
    x: 0.36,
    y: 0.12,
    width: 14.08,
    height: 2.9,
    rx: 1.45
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFE98A",
    fillRule: "nonzero",
    cx: 16.25,
    cy: 16.49,
    r: 7.39
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EEC062",
    fillRule: "nonzero",
    cx: 16.25,
    cy: 16.49,
    r: 5.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.72,15.92 L19.59,15.92 L20.13,14.02 C20.2068642,13.7439126 20.0458588,13.4576807 19.77,13.38 C19.637342,13.3402289 19.494214,13.3561175 19.3735082,13.4240145 C19.2528024,13.4919115 19.1648993,13.6059779 19.13,13.74 L18.5,15.92 L17.5,15.92 L16.74,13.62 C16.6990212,13.4867651 16.6052928,13.3761098 16.4806147,13.3137707 C16.3559365,13.2514316 16.2111753,13.2428421 16.08,13.29 C15.9070888,13.3442198 15.7794511,13.4911964 15.75,13.67 C15.7175377,13.7131073 15.6906578,13.7601472 15.67,13.81 L15.07,15.92 L14.07,15.92 L13.39,13.86 C13.2952736,13.5897651 13.0030237,13.4436401 12.73,13.53 C12.5967651,13.5709788 12.4861098,13.6647072 12.4237707,13.7893853 C12.3614316,13.9140635 12.3528421,14.0588247 12.4,14.19 L13,15.92 L12.8,15.92 C12.57675,15.9837729 12.4228286,16.18782 12.4228286,16.42 C12.4228286,16.65218 12.57675,16.8562271 12.8,16.92 L13.34,16.92 L14.18,19.47 C14.18,19.47 14.18,19.47 14.18,19.47 C14.1972602,19.5132467 14.2208512,19.5536884 14.25,19.59 L14.25,19.65 C14.25,19.65 14.3,19.65 14.32,19.71 C14.3578918,19.7339646 14.3980933,19.7540654 14.44,19.77 L14.78,19.77 L14.85,19.77 L14.85,19.77 C14.9033198,19.7384875 14.9507034,19.6978729 14.99,19.65 L14.99,19.65 C15.032105,19.6019724 15.0598304,19.543056 15.07,19.48 L15.07,19.48 L15.87,17 L16.75,17 L17.51,19.31 C17.5300753,19.368338 17.5605692,19.4225494 17.6,19.47 C17.6496918,19.6364326 17.7821973,19.7651522 17.95,19.81 C18.2260874,19.8868642 18.5123193,19.7258588 18.59,19.45 L19.29,17 L19.72,17 C19.9322101,17.0606193 20.1595693,16.9806795 20.287146,16.8005906 C20.4147227,16.6205017 20.4147227,16.3794983 20.287146,16.1994094 C20.1595693,16.0193205 19.9322101,15.9393807 19.72,16 L19.72,15.92 Z M14.61,17.56 L14.42,16.96 L14.78,16.96 L14.61,17.56 Z M16.17,15.92 L16.28,15.52 L16.41,15.92 L16.17,15.92 Z M18,17.54 L17.85,17 L18.2,17 L18,17.54 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuJungsan);
export default __webpack_public_path__ + "static/media/menu_jungsan.6bf49ba8858cd15da7c5c7a830cdd5de.svg";
export { ForwardRef as ReactComponent };